"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackBox = void 0;
const phaser_1 = __importDefault(require("phaser"));
const Utils_1 = require("../../utils/Utils");
const roundrectangle_js_1 = __importDefault(require("phaser3-rex-plugins/plugins/roundrectangle.js"));
const Fonts_1 = require("../../constants/Fonts");
const TextButton_1 = require("../../common/TextButton");
const ColorPalette_1 = require("../../constants/ColorPalette");
class FeedbackBox extends phaser_1.default.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene);
        this.x = x;
        this.y = y;
        this.width = this.scene.scale.width * 0.87;
        this.height = 306 * Utils_1.Utils.scale;
        this.setPosition(this.x, this.y);
        this.render();
        scene.add.existing(this);
    }
    render() {
        const { scale } = Utils_1.Utils;
        const background = new roundrectangle_js_1.default(this.scene, 0, 0, this.width, this.height, 40 * scale, ColorPalette_1.Colors.FeedbackBoxBackground);
        this.add(background);
        // Add leading text
        const leadingText = this.scene.add
            .text(0, -this.height / 2 + 51 * scale, 'はぐくまファームへのご意見・ご要望は\nご意見 BOXにて承っております', {
            fontFamily: Fonts_1.Fonts.default,
            color: ColorPalette_1.ColorPalette.HelpButtonTitle,
            fontSize: `${25 * scale}px`,
            align: 'center',
            stroke: ColorPalette_1.ColorPalette.HelpButtonTitle,
            strokeThickness: 1,
        })
            .setOrigin(0.5, 0)
            .setLineSpacing(10);
        this.add(leadingText);
        // Add feedback button
        const feedbackButtonText = this.scene.add
            .text(0, 0, 'ご意見BOX')
            .setFontFamily(Fonts_1.Fonts.black)
            .setFontSize(40 * scale)
            .setColor(ColorPalette_1.ColorPalette.Secondary);
        const feedbackButton = new TextButton_1.TextButton(this.scene, {
            x: 0,
            y: 50 * scale,
            width: this.width * 0.697,
            height: 84 * scale,
            radius: 25 * scale,
            backgroundColor: ColorPalette_1.ColorPalette.Primary,
            shadowColor: ColorPalette_1.ColorPalette.PrimaryBold,
            shadowOpacity: 1,
            shadowOffset: 10 * scale,
        }, feedbackButtonText);
        feedbackButton.on('click', Utils_1.handleFeedbackButtonClick);
        this.add(feedbackButton);
    }
}
exports.FeedbackBox = FeedbackBox;
